var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCrackedScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1V23H18.619V1H5ZM8.38871 18.5476H6.57143V5.45238H15.4952L12.5424 9.28523L12.3866 9.48755V9.74294V13.9862L9.78616 17.1367L8.38871 18.5476ZM10.5 18.5476H17.0476V5.89507L13.8866 9.99833V14.2558V14.5253L13.715 14.7332L10.9214 18.1178L10.8997 18.144L10.8758 18.1682L10.5 18.5476ZM17.0476 21.4286H6.57143V20.119H17.0476V21.4286ZM17.0476 3.88095H6.57143V2.57143H17.0476V3.88095Z",
    fill: "#170F4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrackedScreen);
export default __webpack_public_path__ + "static/media/icon-cracked-screen.5929ff279c8b542dc0f6d09592e73767.svg";
export { ForwardRef as ReactComponent };